import { API_BASE_URL } from '../constants/suggestions';

let cachedSuggestions = null;
let cachedKey = null;
let inflightRequest = null;

const buildCacheKey = (token, count) => `${token || ''}:${count || 0}`;

const parseResponse = async (response) => {
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || `HTTP error ${response.status}`);
  }
  return response.json();
};

export const fetchSuggestions = async (token, count = 6) => {
  const response = await fetch(`${API_BASE_URL}/api/suggestions?count=${count}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return parseResponse(response);
};

export const fetchSuggestionsCached = async (token, count = 6, options = {}) => {
  const { forceRefresh = false } = options;
  const cacheKey = buildCacheKey(token, count);

  if (!forceRefresh && cachedKey === cacheKey && cachedSuggestions) {
    return cachedSuggestions;
  }

  if (!forceRefresh && inflightRequest && inflightRequest.key === cacheKey) {
    return inflightRequest.promise;
  }

  const request = fetchSuggestions(token, count)
    .then((data) => {
      cachedKey = cacheKey;
      cachedSuggestions = data;
      return data;
    })
    .finally(() => {
      if (inflightRequest && inflightRequest.key === cacheKey) {
        inflightRequest = null;
      }
    });

  inflightRequest = { key: cacheKey, promise: request };
  return request;
};

export const clearSuggestionsCache = () => {
  cachedSuggestions = null;
  cachedKey = null;
  inflightRequest = null;
};
